import { Component } from 'react';

/**
 * 汎用エラーバウンダリ。子ツリーで JavaScript 例外が発生した場合に
 * 白画面を防ぎ、フォールバック UI を表示する。
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // 本番でも出す。白画面の原因をコンソールから追えるようにするため。
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const backTo = this.props.backTo || '/planner';
      const backLabel = this.props.backLabel || 'プロジェクト一覧に戻る';
      return (
        <div className="max-w-lg mx-auto py-16 px-6 text-center" data-testid="error-boundary-fallback">
          <div className="text-lg font-semibold text-zinc-800 mb-2">
            {this.props.title || 'このプロジェクトを開く際に問題が発生しました。'}
          </div>
          <div className="text-sm text-zinc-500 mb-6">
            {this.props.message || 'もう一度お試しいただくか、プロジェクト一覧へお戻りください。'}
          </div>
          <div className="flex gap-2 justify-center">
            <a
              href={backTo}
              className="inline-flex items-center h-9 px-4 rounded-md border border-zinc-300 text-sm hover:bg-zinc-50"
              data-testid="error-boundary-back"
            >
              {backLabel}
            </a>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="inline-flex items-center h-9 px-4 rounded-md bg-zinc-900 text-white text-sm hover:bg-zinc-800"
              data-testid="error-boundary-reload"
            >
              再読み込み
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
